/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "caption_colors_default": "text-black",
  "caption_size_default": "w-full col-span-12 text-al-body-sm md:text-al-body-lg",
  "caption_variant_default": "",
  "footer_colors_default": "",
  "footer_size_default": "w-full col-span-12 [&:not(:first-child)]:mt-4 [&:not(:first-child)]:md:mt-6",
  "footer_variant_default": "flex items-center justify-center",
  "headline_colors_default": "text-al-petroleum-600",
  "headline_size_default": "w-full col-span-12 text-al-headline-xs md:text-al-headline-sm",
  "headline_variant_default": "",
  "headline_variant_decorated": "flex items-center gap-x-3 after:block after:flex-grow",
  "colors_default": "",
  "size_default": "w-full max-w-screen-xl mx-auto container-col-sm-12:gap-x-2 gap-y-2",
  "size_alternative": "w-full max-w-screen-xl mx-auto gap-x-2 gap-y-8 md:gap-y-2 py-4",
  "variant_default": "relative grid grid-cols-12 auto-rows-min group/row empty:hidden [&:not(:has(:not(.box:empty)))]:hidden [&>*:not(.grid-cols-12)]:col-span-full",
  "button": {
    "extend": {
      "size_medium": "md:px-5.5 md:h-11"
    }
  }
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "Row");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;